import { Link } from 'react-router-dom';
import { featuredWorks } from '@/mocks/homeData';

export default function FeaturedWorks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-medium text-primary-500 uppercase tracking-wider">精选推荐</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
              最新热门作品
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-lg">
              精心挑选平台最受欢迎的影视作品，每一部都是匠心之作
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredWorks.map((work) => (
            <Link
              key={work.id}
              to={`/article/${work.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={work.image}
                  alt={work.title}
                  title={`${work.title} - 麻豆传媒正版影视`}
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/70 text-white backdrop-blur-sm">
                    {work.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md text-xs font-bold bg-accent-500 text-background-950">
                    {work.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 mb-2">
                  {work.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {work.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    {work.year}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-film-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    {work.episodes}集
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}